import { getIngestionModeOptions, requiresCsvArguments } from './IngestionConfigForm.Helpers';
import CsvArgumentsPicker from '../CsvArgumentsPicker/CsvArgumentsPicker';
import FieldDefinition from '../../../types/common/FieldDefinition';
import FieldDefinitions from '../FieldDefinitions/FieldDefinitions';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import IngestionDetails from '../Details/IngestionDetails';
import React from 'react';
import SystemFieldDefinitions from '../FieldDefinitions/SystemFieldDefinitions/SystemFieldDefinitions';
import IngestionMode from '../../../types/ingestion/IngestionMode';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import FormGroup from '../../Common/FormGroup/FormGroup';
import SelectList from '../../Common/SelectList/SelectList';
import guidance from '../Details/IngestionDetails.Guidance';
import CsvIngestionArguments from '../../../types/ingestion/csv/CsvIngestionArguments';
import IngestionFileType from '../Types/FileType';
import { getEmptyCsvSeparator } from '../Pages/IngestionPage/IngestionPage.Helpers';

interface IngestionConfigProps {
    isWaiting: boolean;
    isReadOnly: boolean;
    config: IngestionConfig;
    onChange: (config: IngestionConfig) => void;
    ingestionConfigId: number;
}

class IngestionConfigForm extends React.Component<IngestionConfigProps, { ingestionMode: IngestionMode }> {

    constructor(props: IngestionConfigProps) {
        super(props);

        this.onFieldDefinitionChange = this.onFieldDefinitionChange.bind(this);
        this.onIngestionModeChange = this.onIngestionModeChange.bind(this);
        this.onCsvArgumentsChange = this.onCsvArgumentsChange.bind(this);
        this.onDetailsChange = this.onDetailsChange.bind(this);
    }

    onFieldDefinitionChange(definitions: FieldDefinition[]): void {

        let config = copyObject(this.props.config);

        config.fieldDefinitions= definitions;

        this.props.onChange(config);
    }

    onDetailsChange(config: IngestionConfig) {

        if (config.fileType === IngestionFileType.Json) {

            config.csvSpecification = {} as CsvIngestionArguments;
        }
        else if (!config.csvSpecification) {
            config.csvSpecification = getEmptyCsvSeparator();
        }

        this.props.onChange(config);
    }

    onIngestionModeChange(value: string): void {

        let config = copyObject(this.props.config);

        config.ingestionMode = value as IngestionMode;

        if (value === IngestionMode.Strict) {

            config.fieldDefinitions.forEach((def: FieldDefinition) => def.isRequired = value === IngestionMode.Strict);
        }

        this.props.onChange(config);

        this.setState({ ingestionMode: value as IngestionMode });
    }

    onCsvArgumentsChange(args: CsvIngestionArguments) {

        let config = copyObject(this.props.config);

        config.csvSpecification = args;

        this.props.onChange(config);
    }

    render(): JSX.Element {
        const gridClassName = 'col-12 col-sm-11 col-md-8 col-lg-6 col-xl-5';

        return (
            <>
                {
                    requiresCsvArguments(this.props.config.fileType) &&
                    <>
                        <h3 className="mt-5 mb-5">File Format Details</h3>
                        <div className="row mt-4">
                            <div className={gridClassName}>
                                <CsvArgumentsPicker
                                    isReadOnly={false}
                                    arguments={this.props.config.csvSpecification}
                                    onChange={this.onCsvArgumentsChange} />
                            </div>
                        </div>
                    </>
                }
                {
                    !this.props.isWaiting &&
                    <>
                        <h3 className="mt-5 mb-5">Ingestion Config Details</h3>

                        <div className="row mt-4">
                            <div className={gridClassName}>
                                <IngestionDetails
                                    isReadOnly={this.props.isReadOnly}
                                    config={this.props.config}
                                    onChange={this.onDetailsChange} />
                            </div>
                        </div>
                    </>
                }

                <div>
                    <h3 className="mt-5 mb-5">Field Definitions</h3>

                    <FormGroup label="Ingestion mode:" labelClassName={'margin-0px-20px'} contentClassName={''} info={guidance.ingestionMode}>
                        <SelectList
                            className="form-control"
                            options={getIngestionModeOptions()}
                            value={this.props.config.ingestionMode}
                            onChange={this.onIngestionModeChange}
                            disabled={this.props.isReadOnly} />
                    </FormGroup>
                </div>

                <FieldDefinitions
                    definitions={this.props.config.fieldDefinitions}
                    onChange={this.onFieldDefinitionChange}
                    isReadOnly={this.props.isReadOnly}
                    ingestionConfigId={this.props.ingestionConfigId} />

                <h3 className="mt-5 mb-5">System Fields</h3>

                <SystemFieldDefinitions
                    definitions={this.props.config.fieldDefinitions}
                    onChange={this.onFieldDefinitionChange}
                    isReadOnly={this.props.isReadOnly} />
            </>
        );
    }
}

export default IngestionConfigForm;
